document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('[data-menu-toggle]');const m=document.querySelector('[data-mobile-menu]');if(b&&m){b.addEventListener('click',()=>{m.classList.toggle('open');b.setAttribute('aria-expanded',m.classList.contains('open')?'true':'false')})}document.documentElement.classList.remove('no-js')});


(function(){
  function updateProductForm(form){
    var script = form.querySelector('[data-variants-json]');
    var idInput = form.querySelector('[data-variant-id]');
    var button = form.querySelector('[data-add-to-cart]');
    var selectors = Array.prototype.slice.call(form.querySelectorAll('[data-option-selector]'));
    if(!script || !idInput || !button){ return; }
    var variants;
    try { variants = JSON.parse(script.textContent || '[]'); } catch(e) { variants = []; }
    if(!variants.length){ return; }
    var selected = selectors.map(function(select){ return select.value; });
    var match = variants.find(function(variant){
      return variant.options.every(function(option, index){ return option === selected[index]; });
    });
    if(match){
      idInput.value = match.id;
      var pricesScript = form.querySelector('[data-variant-prices-json]');
      var info = form.closest('.product-info');
      var price = info && info.querySelector('[data-product-price]');
      if(pricesScript && price){
        try { var prices = JSON.parse(pricesScript.textContent); if(prices[String(match.id)]){ price.textContent = prices[String(match.id)]; } } catch(e) {}
      }
      button.disabled = !match.available;
      button.textContent = match.available ? 'Add to cart' : 'Sold out';
    } else {
      button.disabled = true;
      button.textContent = 'Unavailable';
    }
  }

  document.addEventListener('change', function(event){
    if(!event.target.matches('[data-option-selector]')){ return; }
    var form = event.target.closest('[data-product-form]');
    if(form){ updateProductForm(form); }
  });

  document.querySelectorAll('[data-product-form]').forEach(updateProductForm);
})();


(function () {
  function loadProductRecommendations() {
    document.querySelectorAll('.product-recommendations[data-url]').forEach(function (section) {
      if (section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      fetch(section.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var responseHtml = document.createElement('div');
          responseHtml.innerHTML = text;
          var recommendations = responseHtml.querySelector('.product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            section.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(function (error) { console.error('Product recommendations failed to load', error); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadProductRecommendations);
  else loadProductRecommendations();
})();
